/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/MRZ.yaml
import { ScanbotMrzImpl } from './impl';
/**
 * Entry point for all MRZ scanning features.
 */
export const ScanbotMrz = {
    /**
     * Opens the Ready-To-Use UI MRZ scanner with the desired configuration.
     * @param {MrzScannerScreenConfiguration} configuration - The MRZ scanner configuration to be used for scanning.
     * @returns {Promise<ResultWrapper<MrzScannerUiResult>>} - The result of the MRZ scanning operation.
     */
    async startScanner(configuration) {
        return ScanbotMrzImpl.startScanner(configuration);
    },
    /**
     * Scans MRZ from a given image with the desired configuration.
     * @param {ImageInput} params.image - The image to be used for scanning.
     * @param {MrzScannerConfiguration} params.configuration - The MRZ scanner configuration to be used for scanning.
     * @returns {Promise<MrzScannerResult>} - The result of the MRZ scanning operation.
     */
    async scanFromImage(params) {
        return ScanbotMrzImpl.scanFromImage(params);
    },
};
//# sourceMappingURL=Mrz.js.map